import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Spinner from '../misc/spinner'

// This component needs to be refactored when whole page is moved to react.
// Then we could just position the component directly, without the need for `createPortal`.
const SearchHeader = ({ isLoading, isError }) => {
  const children = () => {
    return (
      <>
        {isError &&
          <span>Problem loading search results.</span>}
        {isLoading &&
          <div className='loading-indicator text-center'>
            <Spinner size={0.5} padding={0} loading={true} />
          </div>}
      </>
    )
  }

  return ReactDOM.createPortal(
    children(),
    (document.getElementById('header-summary') || document.createElement('div'))
  )
}
SearchHeader.propTypes = {
  isLoading: PropTypes.bool.isRequired
}
export default SearchHeader
